// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kx-0";